import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    filters: {
      title: 'Filters',
      types: 'Categories',
      audiences: 'Public',
      reset: 'Reset',
      cards: 'Card',
      list: 'List',
      map: 'Map',
      all: 'All',
      fav: 'Fav',
      cancel: 'Cancel',
      apply: 'Apply',
    },
  },
  ro: {
    filters: {
      title: 'Filtre',
      types: 'Categorii',
      audiences: 'Public',
      reset: 'Resetează',
      cards: 'Card',
      list: 'Listă',
      map: 'Hartă',
      all: 'Toate',
      fav: 'Fav',
      cancel: 'Anulează',
      apply: 'Aplică',
    },
  },
}

export default createI18n({
  locale: document.documentElement.lang,
  fallbackLocale: 'ro',
  legacy: false,
  messages,
})
